export default __webpack_public_path__ + "static/MRF-Data-Overview-9d696cd2013ed448a9a417be4109bac7.png";